import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { IMedicalNote } from '../MedicalNote';
import { MedicalNotesApi } from '../../../apis/MedicalNotesApi/MedicalNotesApi';

export function useGetMedicalNote(patientId?: string) {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.medicalNote, patientId],
        queryFn: async () => {
            const result: IMedicalNote = await MedicalNotesApi.getMedicalNote(patientId);
            return result;
        },
        enabled: !!patientId,
    });
}
